import React from "react"
import styles from "./teleworkagenda.module.css"

const TeleworkAgenda = ({ sessions, speakers }) => {
    // Tranform speakers array to object :)
    const speakersObject = {}
    speakers.map(speaker => speakersObject[speaker.name] = speaker)
    
    return (
        <section className={styles.container} id="Agenda">
            <h1>AGENDA</h1>
            {sessions && sessions.filter( data => data.event == 'july' ).map((data, i) => {
                let sessionSpeakers = []
                data.speakers && data.speakers.map(speaker => {
                    if (speakersObject[speaker.name]) {
                        sessionSpeakers.push({...speakersObject[speaker.name], ...speaker})
                    }
                })
                return <Session session={data} sessionSpeakers={sessionSpeakers} key={i} />
            })}
            <p className={styles.pending}>* Pending Agency Approval</p>
        </section>
    )
}

const emptySessions = [
    "networking",
    "lunch"
]
const Session = ({ session, sessionSpeakers }) => {
    const {
        startTime,
        endTime,
        title,
        description,
        type,
        event,
    } = session
    
    return (<div className={styles.session}>
        <div className={styles.session_time}>{startTime} - {endTime}</div>
        <div className={styles.session_divider}>
            <span className={styles.session_divider__circle}></span>
            <span className={styles.session_divider__dotted_line} ></span>
        </div>
        <div className={!emptySessions.includes(type)?styles.triangle:styles.empty_session_triangle}>
            <div className={!emptySessions.includes(type)?styles.inner_triangle:styles.empty_session_inner_triangle}></div>
        </div>
        <div className={ !emptySessions.includes(type)?styles.session_details:styles.empty_session_details}>
            
            <div className={styles.session_title}>{title}</div>
            {sessionSpeakers && sessionSpeakers.map((data, i) => {
                return (<div className={styles.session_description} key={i}>
                    
                    {data.isModerator && <strong>Moderator</strong>}
                    <span className={styles.sName}>{data.name}</span>, <span className={styles.sTitle}>{data.title}</span>
                </div>)
            })}
        </div>
    </div>)
}
export default TeleworkAgenda